import * as React from "react";
import MainLayout from "@/components/template/dashboard-layout";
import CreateCollection from "@/components/organisms/create-collection";
import VideoToFrameContainer from "@/components/utils/videoToFrame";

export default function CreateCollectionPage() {
  return (
    <MainLayout>
      <CreateCollection />
      <VideoToFrameContainer />
    </MainLayout>
  );
}
